import React, { useState, useEffect } from 'react';
import { ScreenContext } from './ScreenContext';

/**
 * Wrapper to make a Provider for the GlobalDataContext.
 * @returns {React.Provider<GlobalDataContext>}
 */
const ScreenProvider = ({ children }) => {
    const [screenSize, setScreenSize] = useState(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 1199px)');

        if (mediaQuery.matches) {
            setScreenSize('desktop');
        } else {
            setScreenSize('mobile');
        }

        mediaQuery.addEventListener('change', ({ matches }) => {
            if (matches) {
                setScreenSize('desktop');
            } else {
                setScreenSize('mobile');
            }
        });
    }, []);

    return (
        <ScreenContext.Provider value={screenSize}>
            {children}
        </ScreenContext.Provider>
    );
};

export default ScreenProvider;
